// @ts-nocheck b4411783
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['POPUPS_X_DesignPanel_More'],
      sections: [
        addPanel.sections.getSections().popup.popUpsCloseIconButtonsSection,
      ],
    };
  },
};
